import { TextColors } from '@picsart/design-system/foundation/colors';
import { FontSizes } from '@picsart/design-system/foundation/typography';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';
import { createUseStyles } from 'react-jss';

interface propsType {
  borderColor?: string;
}

const useStyles = createUseStyles<string, propsType>(
  () => ({
    root: {
      marginBottom: Spacings.s24,
      width: '30%',

      [mediaQuery(1023)]: {
        width: '50%',
      },

      // [mediaQuery(766)]: {
      '@media screen and (max-width: 766px)': {
        width: '100%',
      },
    },
    body: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: [Spacings.s0, 'auto', Spacings.s24],
      height: 160,
      width: 160,
      fontWeight: FontWeights.bold,
      fontSize: FontSizes.s30,
      color: TextColors.base,
      border: props => `${Spacings.s4} solid ${props?.borderColor}`,
      borderRadius: '50%',
    },
    skeleton: {
      borderRadius: '50%',
    },
    title: {
      margin: [Spacings.s0, 'auto'],
      maxWidth: 245,
      fontSize: FontSizes.s20,
      color: TextColors.base,
      textAlign: 'center',

      '& > span': {
        fontWeight: FontWeights.bold,
        color: TextColors.base,
      },
    },
  }),
  { name: 'brands-stat' },
);

export default useStyles;
